module.exports = __webpack_public_path__ + "media/images/Hidenori-85ac615b657948596b5434f837e284a4.jpg";